import { Component, computed, inject, input } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { AgreementsClient } from '@unity/clients';
import { PageContainerComponent } from '@unity/layouts/page-container/page-container.component';
import { ActionSharedComponent } from '@unity/shared/composed/action-shared/action-shared.component';
import { GridDocumentScheduleSharedComponent } from '@unity/shared/grid-document-schedule-shared/grid-document-schedule-shared.component';
import { GridReferenceFileSharedComponent } from '@unity/shared/grid-reference-file-shared/grid-reference-file-shared.component';
import { QuickActions } from '@unity/utils/quick-actions';

@Component({
  selector: 'unity-list-document-page',
  imports: [PageContainerComponent, GridDocumentScheduleSharedComponent, ActionSharedComponent, GridReferenceFileSharedComponent],
  templateUrl: './list-document-page.html',
  styleUrl: './list-document-page.scss',
})
export class ListDocumentPageComponent {
  private readonly agreementsClient = inject(AgreementsClient);

  protected agreementResource = rxResource({
    params: () => {
      const agreementId = this.$agreementId();
      return agreementId ? { agreementId } : undefined;
    },
    stream: ({ params: { agreementId } }) => this.agreementsClient.getOneAsMini(agreementId),
  });

  protected readonly $createDocumentAction = computed(() => {
    const agreementId = this.$agreementId();
    return QuickActions.CreateDocument(agreementId);
  });

  protected readonly $createReferenceFileAction = computed(() => {
    const agreementId = this.$agreementId();
    return QuickActions.CreateReferenceFile(agreementId);
  });

  protected readonly $isAgreementLoading = this.agreementResource.isLoading;
  protected readonly $agreementName = computed(() => (this.agreementResource.hasValue() ? this.agreementResource.value().name : undefined));

  protected readonly $contentHeaderSecondary = computed(() => {
    const agreement = this.$agreementName();
    return `Agreement: ${agreement}`;
  });

  public readonly $agreementId = input.required({ alias: 'agreementId', transform: (value: string) => parseInt(value) });
  protected readonly $returnToAgreementAction = computed(() => QuickActions.ReturnToAgreement(this.$agreementId()));
}
